const CheckVerified = ({ bgcolor, width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "29"}
      height={height || "28"}
      viewBox="0 0 29 28"
    >
      <path
        d="M13.1494 2.30562L17.3886 -0.0810603L20.2591 3.80809L25.093 4.36718L25.1297 9.19965L28.7104 12.4935L25.901 16.4261L26.8618 21.1968L22.2759 22.7271L20.2507 27.1496L15.6403 25.6907L11.4013 28.0797L8.53083 24.1906L3.69698 23.6315L3.65997 18.7967L0.079345 15.5028L2.88867 11.5703L1.92812 6.80191L6.51409 5.2716L8.53928 0.849042L13.1494 2.30562Z"
        fill={bgcolor}
      />
      <path
        d="M8.88412 15.5381C7.46202 14.0082 9.64554 11.7286 11.2269 13.1718C11.7845 13.6802 12.5952 14.4229 13.1574 14.9266L17.4917 9.60134C19.0005 8.04102 21.3831 10.3323 19.8931 11.902L14.4483 18.3963C14.1505 18.7109 13.7422 18.8975 13.3095 18.9167C12.8767 18.9359 12.4535 18.7863 12.1289 18.4994C11.2059 17.6209 9.8517 16.3581 8.88412 15.5381Z"
        fill="white"
      />
    </svg>
  );
};

export default CheckVerified;
